export default __webpack_public_path__ + "static/telemed-top_bana-79ec1918531a74a774e93b8d716a2498.jpg";